function g(e = 0, r = ",") {
  if (e < 0)
    return `-${g(-e)}`;
  let t = Math.trunc(e).toString(), n = "";
  for (; t.length > 3; )
    n = `${r}${t.substring(t.length - 3)}${n}`, t = t.substring(0, t.length - 3);
  return n = `${t}${n}`, n;
}
export {
  g as getFormattedThousand
};
